import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs-compat';
import { TranslateService } from '@ngx-translate/core';
import { RestApiService } from 'src/services/rest-api.service';
import { Location } from '@angular/common';
import '../extended/extensions';
import { TableModel } from 'src/models/table.model';
import { AppModule } from 'src/app/app.module';
import { DialogComponent } from 'src/app/dialog/dialog.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { LocalStoreManager } from 'src/services/local-store-manager.service';

@Component({
    selector: 'app-base',
    template: '<span>mock widget</span>'
})

export class BaseComponent implements OnInit, OnDestroy {

    ngUnsubscribe = new Subject<void>();
    table: TableModel;
    protected dialog: MatDialog;
    protected _snackBar: MatSnackBar;
    protected confirmState: number;
    protected DialogComponent: DialogComponent;
    protected router: Router;
    protected translateText: TranslateService;
    protected api: RestApiService<any>;
    protected _location: Location;
    protected storage: LocalStoreManager;

    constructor() {
        this.api = AppModule.injector.get(RestApiService);
        this.router = AppModule.injector.get(Router);
        this.translateText = AppModule.injector.get(TranslateService);
        this._location = AppModule.injector.get(Location);
        this.dialog = AppModule.injector.get(MatDialog);
        this._snackBar = AppModule.injector.get(MatSnackBar);
        this.storage = AppModule.injector.get(LocalStoreManager);
    }
    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    ngOnInit(): void {
    }
    go(url: string) {
        if (url === 'goback') {
            this._location.back();
            return;
        }
        this.router.navigate([`/${url}`]);
    }
    translate(str: string): string {
        return this.translateText.instant(str);
    }
    test() {
        const str0 = 'str';
        const prefixStr = str0.toAddPrefix('prefix_');
        console.log(prefixStr); // prefix_str
        const arr = ['str'];
        const val = arr.isValid();
        console.log(val);
    }
    confirmation(title: string) {
        const dialogRef = this.dialog.open(DialogComponent);
        dialogRef.componentInstance.confirmation(title);
        dialogRef.afterClosed().subscribe(result => {
            if (result === 'Ok') {
              this.afterConfirm();
            } else {
              return;
            }
        });
    }
    afterConfirm() {
    }
    toast(message: string) {
        this._snackBar.open(message, null, {
            duration: 1000,
        });
    }
    openSnackBar(message, action: string, className: string) {
        if (message instanceof Array) {
            message.forEach((message, index) => {
                setTimeout(() => {
                    this._snackBar.open(message.text, action, {
                        duration: 2000,
                        verticalPosition: 'bottom', // 'top' | 'bottom'
                        horizontalPosition: 'end', //'start' | 'center' | 'end' | 'left' | 'right'
                        panelClass: [className],
                    });
                }, index * (2000 + 500)); // 500 => timeout between two messages
            });
        } else {
            this._snackBar.open(message.text, action, {
                duration: 1000,
                verticalPosition: 'bottom', // 'top' | 'bottom'
                horizontalPosition: 'end', //'start' | 'center' | 'end' | 'left' | 'right'
                panelClass: [className],

            });
        }
    }
}
